export default __webpack_public_path__ + "static/media/empty_basket.04885760.svg";